// src/index.js

import React from 'react';
import ReactDOM from 'react-dom';
import { ChakraProvider, extendTheme } from '@chakra-ui/react';
import App from './App';
import './index.css';  // Ensure this imports the custom font from index.css

const theme = extendTheme({
  fonts: {
    heading: 'FjallaOne, sans-serif',
    body: 'FjallaOne, sans-serif',
  },
});

ReactDOM.render(
  <ChakraProvider theme={theme}>
    <App />
  </ChakraProvider>,
  document.getElementById('root')
);
